module.exports = __webpack_public_path__ + "static/img/home_product_03_zh.2f8083c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_03_zh.png
// module id = ABPw
// module chunks = 34